import React, { memo, useMemo } from "react";
import { Link, useParams } from "react-router-dom";

import { ArrowBreadcrumb } from "../../components/icons";
import { LoadingOverlay } from "../../components/LoadingOverlay/LoadingOverlay";
import { PageTitle } from "../../components/PageTitle";
import { useOrganizationContext } from "../../contexts/organizations/organizationsContext";
import {
  useApplications,
  useSingleApplication,
} from "../../hooks/reactQueryHooks/useApplications";
import { useCacheItemsCount } from "../../hooks/reactQueryHooks/useCacheItems";
import { usePlaygroundModels } from "../../hooks/reactQueryHooks/usePlayground";
import { ApplicationsDetailsPage } from "./components/ApplicationsDetailsPage";

const applicationsBreadcrumbs = [
  {
    title: "Projects",
    path: "",
    isSeparator: false,
    isActive: false,
  },
  {
    title: "",
    path: "",
    isSeparator: true,
    isActive: false,
  },
  {
    title: "Manage project",
    path: "",
    isSeparator: false,
    isActive: false,
    to: "/projects",
  },
];

const ApplicationsDetailsWrapper: React.FC = memo(() => {
  const { currentOrganization } = useOrganizationContext();

  const { projId } = useParams();
  const organizationId: string = currentOrganization?.id || "";

  const { data, isLoading, isFetching } = useSingleApplication(
    organizationId,
    projId || "",
  );
  const { data: applications } = useApplications(organizationId);
  const { data: cacheItemsCount } = useCacheItemsCount(
    organizationId,
    projId || "",
  );
  const {
    data: models,
    isLoading: modelsLoading,
    isFetching: modelsFetching,
  } = usePlaygroundModels();

  const currentApp = useMemo(() => {
    return applications?.find(app => app.id === projId);
  }, [projId, applications]);

  return (
    <>
      <div className="d-flex align-items-center">
        {(isLoading || isFetching) && <LoadingOverlay />}
        <Link to="/projects" className="me-3">
          <ArrowBreadcrumb className="svg-icon" />
        </Link>
        <PageTitle
          breadcrumbs={applicationsBreadcrumbs}
          breadcrumbTitle=" "
          pageTitle={currentApp?.name || ""}
        />
      </div>
      <ApplicationsDetailsPage
        data={data}
        cacheItemsCount={cacheItemsCount}
        isLoading={isLoading || isFetching || modelsLoading || modelsFetching}
        models={models}
      />
    </>
  );
});

export { ApplicationsDetailsWrapper };
